"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedValueType = void 0;
var SelectedValueType;
(function (SelectedValueType) {
    SelectedValueType["percentage"] = "percentage";
    SelectedValueType["amount"] = "amount";
})(SelectedValueType = exports.SelectedValueType || (exports.SelectedValueType = {}));
//# sourceMappingURL=commission-view-model.js.map